import React from "react";
import styled from "styled-components";
import { PrimaryBold, Small } from "@ui/components/containers/primary";
import { RoundedBlock } from "@ui/components/containers/roundedBlock";
import { Stack, stack } from "@ui/components/layout";
// import { LoadingButton } from "../../components/buttons/loadingButton";
// import { useServices } from "../../../core/servicesContext";
// import { usePrivacyConfirmation } from "./privacy/usePrivacyConfirmation";
// import { useAsync } from "../../../utils/hooks";
// import { createToast } from "../../toasts/utils";
import { I18n } from "@assets/strings";
import { useLocation } from "react-router";
import { useHistory } from "@core/routing/useHistory";
// import { PhoneNumberAuthModal } from "../../components/auth/phoneNumberAuthModal";
import { Path } from "@core/routing/path";
import type { AuthLocationState } from "./authPage";
import { useServices } from "@core/servicesContext";
import { PrimaryButton } from "@ui/components/buttons/primaryButton";
import { SocialLogin } from "./socialLogin";

export const SocialLoginCard: React.FC = () => {
	// const { currentProfileService, trackingService } = useServices();
	// const askPrivacy = usePrivacyConfirmation();

	// const { run, loading } = useAsync(
	// 	async (authProvider: "Google" | "Facebook" | "Apple") => {
	// 		const validated = await askPrivacy();
	// 		if (!validated) {
	// 			return;
	// 		}
	// 		try {
	// 			await currentProfileService.login(authProvider);
	// 			trackingService.track("login", { provider: authProvider });
	// 		} catch (e) {
	// 			createToast(I18n.t("error"), I18n.t("auth.error.default"), "error");
	// 		}
	// 	},
	// 	[askPrivacy]
	// );

	const history = useHistory();
	const location = useLocation();
	const { currentProfileService } = useServices();

	// const openPhoneNumberAuthModal = (): void => {
	// 	createModal((close) => <PhoneNumberAuthModal close={close} />);
	// };

	// const theme = useTheme();
	return (
		<Container>
			<Stack gap={8}>
				<PrimaryBold>{I18n.t("login.card.title")}</PrimaryBold>
				<Small>{I18n.t("login.card.description")}</Small>
			</Stack>
			<Buttons>
				{/* <Bloc onClick={() => openPhoneNumberAuthModal()}>
					<Button loading={loading} loadingColor={theme.colors.primary}>
						<img src={require("../../../assets/images/auth/Phone.svg")} />
					</Button>
					<PrimaryMedium>{I18n.t("login.button.phone")}</PrimaryMedium>
				</Bloc>
				<Bloc onClick={() => run("Facebook")}>
					<Button loading={loading} loadingColor={theme.colors.primary}>
						<img src={require("../../../assets/images/auth/facebook.svg")} />
					</Button>
					<PrimaryMedium>{I18n.t("login.button.facebook")}</PrimaryMedium>
				</Bloc>
				<Bloc onClick={() => run("Google")}>
					<Button loading={loading} loadingColor={theme.colors.primary}>
						<img src={require("../../../assets/images/auth/google.svg")} />
					</Button>
					<PrimaryMedium>{I18n.t("login.button.google")}</PrimaryMedium>
				</Bloc>
				<Bloc onClick={() => run("Apple")}>
					<Button loading={loading} loadingColor={theme.colors.primary}>
						<img src={require("../../../assets/images/auth/apple.svg")} />
					</Button>
					<PrimaryMedium>{I18n.t("login.button.apple")}</PrimaryMedium>
				</Bloc> */}
				<SocialLogin />
				<PrimaryButton
					style={{ width: "100%" }}
					onClick={() => {
						currentProfileService.setPostLoginLocation(location.pathname);
						history.push(Path.Root, { initialMode: "signup" } satisfies AuthLocationState);
					}}
				>
					{I18n.t("register.button.submit")}
				</PrimaryButton>
			</Buttons>
		</Container>
	);
};

const Container = styled(RoundedBlock)`
	padding: 10px 20px;
	${stack(20)}
`;

const Buttons = styled.div.withConfig({
	shouldForwardProp: (prop) => prop !== "isCard",
})<{ isCard?: boolean }>`
	display: flex;
	width: 100%;
	${stack(20, "space-between", "baseline")};
`;

// const Button = styled(LoadingButton)`
// 	background-color: ${({ theme }) => theme.colors.white};
// 	box-shadow: 0 4px 16px 0 rgba(0, 0, 0, 0.1);
// 	&:hover {
// 		background-color: ${({ theme }) => theme.colors.lightergray};
// 	}
// 	color: ${({ theme }) => theme.colors.primary};
// 	padding: 0;
// 	width: 40px;
// 	height: 40px;
// 	border-radius: 20px;
// 	text-align: center;

// 	img {
// 		max-width: 16px;
// 	}
// `;

// const Bloc = styled(RoundedBlock)`
// 	background-color: ${({ theme }) => theme.colors.white};
// 	box-shadow: 0 4px 16px 0 rgba(0, 0, 0, 0.1);
// 	&:hover {
// 		background-color: ${({ theme }) => theme.colors.lightergray};
// 	}
// 	cursor: pointer;
// 	width: 100%;
// 	${row(10, "flex-start", "center")};
// 	padding: 4px;
// `;
